/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aistudiodescription2Inputs */

const en_aistudiodescription2 = /** @type {(inputs: Aistudiodescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create events, images and videos with the power of AI.`)
};

const de_aistudiodescription2 = /** @type {(inputs: Aistudiodescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erstelle Events, Bilder und Videos mit KI.`)
};

/**
* | output |
* | --- |
* | "Create events, images and videos with the power of AI." |
*
* @param {Aistudiodescription2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aistudiodescription2 = /** @type {((inputs?: Aistudiodescription2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aistudiodescription2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aistudiodescription2(inputs)
	return de_aistudiodescription2(inputs)
});
export { aistudiodescription2 as "aiStudioDescription" }